import React, { useContext } from 'react'
import IptvDefaultPage from './iptvPages/iptvDefaultPage'
import { isEmpty } from 'lodash'
import { TemplateContext } from '../../context/template'
import { AppContext } from '../../context/app'
import Channel from '../channel'
import IPTV from '../iptv'
import IptvPlaylist from './iptvPlaylist'

const IptvTemplate = () => {
  const { accountObj } = useContext(AppContext)
  const { iptvTemplateData, iptvTemplateLoaded } = useContext(TemplateContext)

  const isIptvPlaylistAllowed = accountObj?.od_resource_allowances?.is_iptv_playlist_allowed
  const isEpgDesignAllowed = accountObj?.od_resource_allowances?.is_epg_design_allowed

  const getPage = (key, data) => {
    if (!key) return

    let pageProps = {
      // data: { ...data, aligned: 'LEFT' },
      data,
      modifyData: () => {},
      setModalState: () => {},
      isEdit: false,
    }
    let componentObj = {
      iptvDefaultPage: <IptvDefaultPage {...pageProps} />,
    }

    return componentObj[key]
  }

  const getPageComponent = () => {
    if (!isEpgDesignAllowed) {
      return <Channel />
    }

    if (isEpgDesignAllowed && isIptvPlaylistAllowed) {
      if (iptvTemplateLoaded) {
        if (!isEmpty(iptvTemplateData)) {
          return getPage(
            iptvTemplateData.template_data.template_key,
            iptvTemplateData.template_data.data,
          )
        } else {
          return <IptvPlaylist />
        }
      } else {
        return null
      }
    }

    if (isEpgDesignAllowed && !isIptvPlaylistAllowed) {
      return <IPTV />
    }

    return null
  }

  return <div className="w-full h-full">{iptvTemplateLoaded ? getPageComponent() : null}</div>
}

export default IptvTemplate
